import { PricingHero } from '@components/pricing/PricingHero';
import { Partners } from '@components/pricing/Partners';
import { PricingSection } from '@components/pricing/PricingSection';
import { PricingTiers } from '@components/pricing/PricingTiers';
import { PricingFooter } from '@components/pricing/PricingFooter';
import { PricingEnterprise } from '@components/pricing/PricingEnterprise';
import { singlePageProps } from '@lib';

const Pricing = () => {
  return (
    <div className="mt-[-80px] overflow-clip bg-newGray-50 pt-[80px]">
      <section className="pb-12">
        <PricingHero />
        <PricingTiers />
        <PricingEnterprise />
        <Partners />
      </section>
      <section className="relative bg-white py-16">
        <PricingSection />
      </section>
      <PricingFooter />
    </div>
  );
};

export default Pricing;

export async function getStaticProps({ preview = false }) {
  return singlePageProps({ preview, slug: '/pricing' });
}
